import React from 'react';
import LogoLoop from './LogoLoop';

const TechStack = () => {
  /**
   * 🎨 CARA MENAMBAH LOGO BARU:
   * 
   * 1. Simpan file logo (png/jpg/svg) di folder: public/assets/logos/
   * 2. Tambahkan entry baru di array techLogos di bawah:
   *    {
   *      name: 'Nama Teknologi',
   *      image: '/assets/logos/nama-file.png'
   *    },
   * 3. Selesai! Logo akan otomatis muncul di animasi
   * 
   * Tips:
   * - Gunakan PNG dengan background transparan untuk hasil terbaik
   * - Ukuran minimal 200x200px
   * - Nama file lowercase dengan dash (contoh: auto-cad.png)
   */

  const techLogos = [
    // Web Development
    { name: 'React', image: '/assets/logos/React.png' },
    { name: 'Node.js', image: '/assets/logos/Node.js.png' },
    { name: 'Vue.js', image: '/assets/logos/Vue.js.png' },
    { name: 'JavaScript', image: '/assets/logos/JavaScript.png' },
    { name: 'Python', image: '/assets/logos/python_icon.png' },
    { name: 'Tailwind CSS', image: '/assets/logos/Tailwind CSS.png' },
    { name: 'NPM', image: '/assets/logos/NPM.png' },
    
    // Database
    { name: 'MongoDB', image: '/assets/logos/MongoDB.png' },
    { name: 'Firebase', image: '/assets/logos/Firebase.png' },
    
    // IoT & Engineering Tools
    { name: 'Arduino', image: '/assets/logos/Arduino.png' },
    { name: 'KiCAD', image: '/assets/logos/kicad.png' },
    { name: 'EasyEDA', image: '/assets/logos/EasyEDA.png' },
    { name: 'Fusion 360', image: '/assets/logos/fusion-360-icon.png' },
    { name: 'MATLAB', image: '/assets/logos/MATLAB.png' },
    { name: 'C++', image: '/assets/logos/C++.png' },
    { name: 'OpenCV', image: '/assets/logos/OpenCV.png' },
    
    // DevOps & Cloud
    { name: 'Git', image: '/assets/logos/Git.png' },
    { name: 'GitHub', image: '/assets/logos/GitHub.png' },
    { name: 'GitLab', image: '/assets/logos/GitLab.png' },
    { name: 'Vercel', image: '/assets/logos/Vercel.png' },
    { name: 'Heroku', image: '/assets/logos/Heroku.png' },
    { name: 'Digital Ocean', image: '/assets/logos/digital_ocean_icon.png' },
    { name: 'NGINX', image: '/assets/logos/NGINX.png' },
    
    // Development Tools
    { name: 'VS Code', image: '/assets/logos/VS-Code.png' },
    { name: 'JetBrains', image: '/assets/logos/JetBrains.png' },
    { name: 'Jupyter', image: '/assets/logos/Jupyter.png' },
    { name: 'Kaggle', image: '/assets/logos/Kaggle.png' },
    
    // Operating Systems
    { name: 'Linux', image: '/assets/logos/Linux.png' },
    { name: 'Debian', image: '/assets/logos/Debian.png' },
    
    // Design Tools
    { name: 'Canva', image: '/assets/logos/Canva.png' },
  ];

  // Render logo dari file gambar
  const logos = techLogos.map((tech, index) => (
    <div 
      key={index} 
      className="flex flex-col items-center gap-2 px-4"
      style={{ minWidth: '120px' }}
    >
      <img
        src={tech.image}
        alt={tech.name}
        className="w-20 h-20 object-contain"
        style={{ 
          filter: 'drop-shadow(0 2px 8px rgba(0, 0, 0, 0.3))',
          imageRendering: 'crisp-edges'
        }}
        onError={(e) => {
          // Fallback jika gambar tidak ditemukan
          e.target.style.display = 'none';
          console.warn(`Logo not found: ${tech.image}`);
        }}
      />
      <span className="text-xs text-slate-400 font-medium text-center">
        {tech.name}
      </span>
    </div>
  ));

  return (
    <section className="py-16 px-6 relative overflow-hidden" style={{ background: 'transparent' }}>
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl sm:text-4xl font-bold text-white mb-4" 
            style={{ fontFamily: 'Space Grotesk, sans-serif' }}
          >
            Tech Stack & Tools
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Teknologi dan tools yang kami kuasai untuk membangun solusi engineering terbaik
          </p>
        </div>

        <div className="relative w-full">
          <LogoLoop
            logos={logos}
            speed={80}
            direction="left"
            width="100%"
            logoHeight={100}
            gap={60}
            hoverSpeed={20}
            fadeOut={false}
            scaleOnHover={true}
            ariaLabel="Technology stack logos"
            className="py-8"
          />
        </div>

        {/* Decorative gradient lines */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent"></div>
        <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent"></div>
      </div>
    </section>
  );
};

export default TechStack;
